import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { Box, Button } from "@mui/material";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";

function getVesselPermitPreferences(preferences, vesselPermits) {
  if (!preferences || preferences.length === 0) {
    console.warn("No vessel permit preferences provided");
    return [];
  }

  if (!vesselPermits || vesselPermits.length === 0) {
    console.warn("No vessel permit to select");
    return [];
  }

  let tripVesselPermitPreferences = [];
  let vesselPermitPreferences = [];
  for (let e = 0; e < preferences.length; e++) {
    if (!tripVesselPermitPreferences.includes(preferences[e])) {
      tripVesselPermitPreferences[tripVesselPermitPreferences.length] =
        preferences[e];
      for (let f = 0; f < vesselPermits.length; f++) {
        if (Number(vesselPermits[f].PNUM) === Number(preferences[e])) {
          vesselPermitPreferences[vesselPermitPreferences.length] = {
            PNUM: vesselPermits[f].PNUM,
            HULL_ID: vesselPermits[f].HULL_ID,
            VES_NAME: vesselPermits[f].VES_NAME,
          };
          break;
        }
      }
    }
  }
  return vesselPermitPreferences;
}

const styles = {
  autocomplete: {
    maxWidth: window.innerWidth < 750 ? "90%" : "350px",
    minWidth: window.innerWidth < 750 ? "90%" : "250px",
  },
};

export default function VesselPermit(props) {
  const selectedValue = {
    PNUM: props.vessel_permit_num,
    HULL_ID: props.vessel_registration,
    VES_NAME: props.vessel_name,
  };

  const vesselPermitPreferences = getVesselPermitPreferences(
    props.preferences,
    props.vessel_permit_options
  );

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    ignoreCase: true,
    trim: true,
    stringify: (option) =>
      option.PNUM + " " + option.HULL_ID + " " + option.VES_NAME,
  });

  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Vessel Permit</h2>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid item xs={12} md="auto">
          <Box display="flex" flexWrap="wrap" justifyContent="center">
            {vesselPermitPreferences.map((trip, idx) => (
              <Box m={0.5} key={idx}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="form-input"
                  data-pnum={trip.PNUM}
                  data-hull-id={trip.HULL_ID}
                  data-ves-name={trip.VES_NAME}
                  data-field={"vessel_permit"}
                  size="large"
                  onClick={(e) =>
                    props.handleTripPermitPreferenceChange(e, trip)
                  }
                  key={trip.PNUM}
                >
                  {trip.PNUM + " - " + trip.HULL_ID + " " + trip.VES_NAME}
                </Button>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item xs={12} md="auto">
          <Autocomplete
            id="vessel_permit_autocomplete"
            options={props.vessel_permit_options}
            getOptionLabel={(option) =>
              option.PNUM + " " + option.HULL_ID + " " + option.VES_NAME
            }
            style={styles.autocomplete}
            onChange={props.changeHandler}
            isOptionEqualToValue={(option) =>
              option.PNUM + " " + option.HULL_ID + " " + option.VES_NAME
            }
            defaultValue={
              props.vessel_permit_options.length === 1
                ? props.vessel_permit_options[0]
                : null
            }
            value={selectedValue}
            disabled={props.vessel_permit_options.length === 1}
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ style: { fontSize: 18 } }}
                label="Vessel Permit"
                variant="standard"
                helperText="Name or Permit Number"
              />
            )}
            filterOptions={filterOptions}
          />
        </Grid>
        <Grid item>
          <HelpText helpText={getHelpText(props.helpText, "vessel")} />
        </Grid>
      </Grid>
    </Box>
  );
}
